import { render, staticRenderFns } from "./unauthorised.vue?vue&type=template&id=342aa9a8&"
import script from "./unauthorised.vue?vue&type=script&lang=js&"
export * from "./unauthorised.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports